import {trackAmplitudeEvent} from "@pg-mono/amplitude";

import {getAmplitudeOfferPromotionEventProperties, IAmplitudeOfferPromotionTrackingParams} from "./get_amplitude_offer_promotion_event_properties";

export const trackAmplitudeOfferViewPromotion = (context: IAmplitudeOfferPromotionTrackingParams) => {
    trackAmplitudeEvent("view_promotion", getAmplitudeOfferPromotionEventProperties(context));
};

export const trackAmplitudeOfferSelectPromotion = (context: IAmplitudeOfferPromotionTrackingParams) => {
    trackAmplitudeEvent("select_promotion", getAmplitudeOfferPromotionEventProperties(context));
};
import {trackAmplitudeEvent} from "@pg-mono/amplitude";

import {getAmplitudeOfferPromotionEventProperties, IAmplitudeOfferPromotionTrackingParams} from "./get_amplitude_offer_promotion_event_properties";

export const trackAmplitudeOfferViewPromotion = (context: IAmplitudeOfferPromotionTrackingParams) => {
    trackAmplitudeEvent("view_promotion", getAmplitudeOfferPromotionEventProperties(context));
};

export const trackAmplitudeOfferSelectPromotion = (context: IAmplitudeOfferPromotionTrackingParams) => {
    trackAmplitudeEvent("select_promotion", getAmplitudeOfferPromotionEventProperties(context));
};
